export const WITHDRAWAL_SEARCH_PARAMETER = "-01-01"; // first day of the year

export const WITHDRAWAL_START_ON_CHART_GAP = 1;
